import { render } from "./CancelUserRolesModal.vue?vue&type=template&id=0be88fb4&scoped=true"
import script from "./CancelUserRolesModal.vue?vue&type=script&lang=js"
export * from "./CancelUserRolesModal.vue?vue&type=script&lang=js"

import "./CancelUserRolesModal.vue?vue&type=style&index=0&id=0be88fb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be88fb4"]])

export default __exports__